import "../chunk-MQXBDTVK.js";

// src/providers/public.ts
import { providers } from "ethers";
function publicProvider() {
  let {
    priority,
    stallTimeout,
    weight
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (chain) {
    if (!chain.rpcUrls.default.http[0]) return null;
    return {
      chain,
      provider: () => {
        var _chain$contracts, _chain$contracts$ensR;
        const provider = new providers.StaticJsonRpcProvider(chain.rpcUrls.default.http[0], {
          chainId: chain.id,
          name: chain.network,
          ensAddress: (_chain$contracts = chain.contracts) === null || _chain$contracts === void 0 ? void 0 : (_chain$contracts$ensR = _chain$contracts.ensRegistry) === null || _chain$contracts$ensR === void 0 ? void 0 : _chain$contracts$ensR.address
        });
        return Object.assign(provider, {
          priority,
          stallTimeout,
          weight
        });
      }
    };
  };
}
export { publicProvider };